export default "__VITE_PUBLIC_ASSET__1a3aa598__"